import { render, staticRenderFns } from "./reportCenter.vue?vue&type=template&id=580aa7ff&scoped=true&"
import script from "./reportCenter.vue?vue&type=script&lang=js&"
export * from "./reportCenter.vue?vue&type=script&lang=js&"
import style0 from "./reportCenter.vue?vue&type=style&index=0&id=580aa7ff&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580aa7ff",
  null
  
)

export default component.exports